import { map } from 'lodash/fp';
// datetime functions are provided through @mews/framework and luxon should not be used directly
// eslint-disable-next-line import/no-extraneous-dependencies
import { DateTime, Interval } from 'luxon';
import { DateTimeService, DateTimeUtcService, toDateTimeLuxon } from '@mews/framework';

const convertUtcStringToDateTimeFromMillis = (utcString: string, timezone: string) => {
    /**
     * DateTime object from UTC is different than DateTime from millis.
     * splitBy method accepts DateTime from millis.
     */

    const { millis } = DateTimeService.fromUtcString(utcString, timezone);

    return DateTime.fromMillis(millis);
};

const convertIntervalsToUtcIntervals = (intervals: $TSFixMe) =>
    map(({ e, s }) => ({
        endUtc: DateTimeUtcService.fromEpoch(e.ts).value,
        startUtc: DateTimeUtcService.fromEpoch(s.ts).value,
    }))(intervals);

export const getIntervalUnitLength = ({ startUtc, endUtc }: $TSFixMe, durationUnit: $TSFixMe, timezone: string) =>
    Interval.fromDateTimes(
        convertUtcStringToDateTimeFromMillis(startUtc, timezone),
        convertUtcStringToDateTimeFromMillis(endUtc, timezone)
    ).length(durationUnit);

export const getDividedDateRangeByTimeUnit = ({
    interval,
    timeUnit,
    unitAmount,
    timezone,
}: {
    interval: $TSFixMe;
    timeUnit: $TSFixMe;
    unitAmount: $TSFixMe;
    timezone: string;
}) => {
    const intervals = Interval.fromDateTimes(
        convertUtcStringToDateTimeFromMillis(interval.startUtc, timezone),
        convertUtcStringToDateTimeFromMillis(interval.endUtc, timezone)
    ).splitBy({ [timeUnit]: unitAmount });
    return convertIntervalsToUtcIntervals(intervals);
};

export const convertUtcRangeToInterval = ({ endUtc, startUtc }: $TSFixMe, timezone: string) => {
    /**
     * Date time with millis is required for luxon operations
     */
    const endDateTime = DateTimeService.fromUtcString(endUtc, timezone);
    const startDateTime = DateTimeService.fromUtcString(startUtc, timezone);
    return Interval.fromDateTimes(toDateTimeLuxon(startDateTime), toDateTimeLuxon(endDateTime));
};

export const getMissingIntervals = ({
    subjectUtcRange,
    loadedUtcRanges,
    timezone,
}: {
    subjectUtcRange: $TSFixMe;
    loadedUtcRanges: $TSFixMe;
    timezone: string;
}) => {
    const subjectInterval = convertUtcRangeToInterval(subjectUtcRange, timezone);
    const loadedIntervals = map((range) => convertUtcRangeToInterval(range, timezone))(loadedUtcRanges);
    const missingIntervals = subjectInterval.difference(...loadedIntervals);
    return convertIntervalsToUtcIntervals(missingIntervals);
};

export const getFirstDayOfMonthUtc = (timeUtc: string, timezone: string) => {
    const dateTime = DateTimeService.fromUtcString(timeUtc, timezone);
    return DateTimeService.toUtc(DateTimeService.startOfMonth(dateTime)).value;
};

export const getLastDayOfMonthUtc = (timeUtc: string, timezone: string) => {
    const dateTime = DateTimeService.fromUtcString(timeUtc, timezone);
    return DateTimeService.toUtc(DateTimeService.endOfMonth(dateTime)).value;
};
